function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18",
  height: "18",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("text", {
  transform: "translate(-1 -1)",
  fill: "#5F7682",
  fillRule: "evenodd",
  fontFamily: "material",
  fontSize: "20"
}, /*#__PURE__*/React.createElement("tspan", {
  x: "0",
  y: "17"
}, " \uE9A4 "))));